/* log_link.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.32 19.89" xml:space="preserve">
            <path class="foreground-gl" d="M10.64.51l3.74,3.74a.75.75,0,0,1,.22.53V19.43a.75.75,0,0,1-.75.75H1a.75.75,0,0,1-.75-.75V1A.75.75,0,0,1,1,.29h9.07A.75.75,0,0,1,10.64.51ZM10.13,5,13.7,5l-3.82-4V4.73A.27.27,0,0,0,10.13,5ZM6.84,9.61H12V6.91H6.84Zm0,5.81H12v-2.7H6.84ZM3.63,6.69a1.7,1.7,0,1,0,1.7,1.7A1.7,1.7,0,0,0,3.63,6.69Zm0,5.87a1.71,1.71,0,1,0,1.7,1.7A1.7,1.7,0,0,0,3.63,12.56Z" transform="translate(-0.29 -0.29)"/>
        </svg>
    `
};
